module.exports = __webpack_public_path__ + "static/media/lady_zoomedout.3ec2b858.jpg";